import DataType from '../../../constant/DataType';

export enum AppListFilterField {
  PACKAGE_NAME = 'packageName',
  IS_IN_STORE = 'isInStore',
  APP_NAME = 'appName',
  PERMISSIONS = 'permissions',
  INSTALL_DATE = 'installDate',
}

export interface AppListFilterFieldInfo {
  field: AppListFilterField;
  label: string;
  dataType: DataType;
}

export const APP_LIST_FILTER_FIELDS: AppListFilterFieldInfo[] = [
  { field: AppListFilterField.PACKAGE_NAME, label: 'Package Name', dataType: DataType.STRING },
  { field: AppListFilterField.IS_IN_STORE, label: 'Is In Store', dataType: DataType.BOOLEAN },
  { field: AppListFilterField.APP_NAME, label: 'App Name', dataType: DataType.STRING },
  { field: AppListFilterField.PERMISSIONS, label: 'Permissions', dataType: DataType.STRING },
  { field: AppListFilterField.INSTALL_DATE, label: 'Install Date', dataType: DataType.DATE },
];
